export type EnvironmentProp =
    | 'prod'
    | 'release'
    | 'production'
    | 'dev'
    | 'local'
    | 'development'
    | 'staging'
    | 'beta'
    | 'pre-release';
export const environment = process.env.NODE_ENV;

/**
 * Check if is hosted on a non local env
 * @returns {boolean}
 */
export const isHosted = () =>
    !(
        // Ignore development hosts
        /^(localhost|192|\.test)/.test(window.location.host)
    );

/**
 * Detect Environment
 * @param env
 * @returns {boolean}
 */
export const isEnvironment = (env: EnvironmentProp) => {
    let _env;

    switch (`${environment || 'prod'}`.toLowerCase()) {
        case 'prod':
        case 'release':
        case 'production':
            _env = 'production';
            break;

        case 'dev':
        case 'local':
        case 'development':
            _env = 'development';
            break;

        case 'staging':
        case 'beta':
        case 'pre-release':
            _env = 'staging';
            break;

        default:
            _env = 'production';
            break;
    }

    return env === _env;
};

/**
 * Detect if it's production
 * @returns {boolean}
 */
export const isProduction = () => isEnvironment('production');

/**
 * Detect if it's Development
 * @returns {boolean}
 */
export const isDevelopment = () => isEnvironment('development');
